// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button{padding:5px 20px}.p-button.p-button-primary,.p-button.p-button-success{background-color:var(--123-green)}.p-button.p-button-secondary{background-color:#000}.p-button-icon-only,.p-button.rounded-button{border-radius:10px}", ""]);
// Exports
module.exports = exports;
